<div class="background" [ngClass]="{'extra-column': userDataService.assetInfo.parentId > 0 && userDataService.assetInfo.assistances.length > 0}">
  <div ngClass="{{logoChanged ? 'no-logo' : 'logo'}}">@if (logoChanged) {
    <img [src]="logo" class="whitelabel">
  }</div>

  @if (userDataService.assetInfo.parentId == 0) {
    <div class="assistances">
      <p class="title" #headerElementAsset [matTooltip]="headerTruncatedAsset ? userDataService.assetInfo.name : ''">{{ userDataService.assetInfo.name }}</p>
    </div>
  }

  @if (userDataService.assetInfo.parentId > 0 && userDataService.assetInfo.assistances.length > 0) {
    <div class="assistances">
      <p class="title" #headerElementAssistance [matTooltip]="headerTruncatedAssistance ? userDataService.assetInfo.assistances[0].name + '-' + userDataService.assetInfo.name  : ''">{{ userDataService.assetInfo.assistances[0].name }} - <span class="asset-title">{{ userDataService.assetInfo.name }}</span></p>
    </div>
  }

  @if (userDataService.assetInfo.parentId > 0 && userDataService.assetInfo.assistances.length > 0) {
    <div class="assistances assistance-status responsive-off" matTooltip="{{ !isExpert ? ('ASSISTANCES.CANT_START_ASSISTANCE' | translate) : '' }}">
      @if (assistanceClosed) {
        <div class="assistance-reopen">
          <button mat-raised-button (click)="reopenAssistance()" [disabled]="!isExpert">{{ 'ASSISTANCES.REOPEN_ASSISTANCE' | translate }}</button>
        </div>
      }
      @if (!assistanceClosed){
        <div class="header-select" matTooltip="{{ isExpert ? ('ASSISTANCES.STATES' | translate) : '' }}">
          <mat-form-field class="assistances-select" appearance="outline">
            <mat-select #stateSelect (selectionChange)="changeAssistanceStatus(stateSelect)" [(value)]="assistanceState" panelWidth="auto" [disabled]="!isExpert">
              @for (state of assisatancesStatesOptions; track state) {
                <mat-option [value]="state.value">{{ 'ASSISTANCES_STATES.' + state.key | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if (!assistanceClosed){
        <div class="header-select" matTooltip="{{ isExpert ? ('ASSISTANCES.PRIORITIES' | translate) : '' }}">
          <mat-form-field class="assistances-select assistances-priority" appearance="outline">
            <mat-select #prioritySelect (selectionChange)="changeAssistancePriority(prioritySelect)" [(value)]="assistancePriority" panelWidth="auto" [disabled]="!isExpert || userDataService.assetInfo.assistances[0].id == undefined">
              @for (key of objectKeys(assistancePriorityEnum); track key) {
                <mat-option [value]="assistancePriorityEnum[key]">{{ 'ASSISTANCES_PRIORITY.' + key | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>
  }

  @if (isExpert) {
    <div class="library responsive-off" matTooltip="{{ 'GENERAL.LIBRARY' | translate }}" (click)="openLibrary()">
      <img src="/assets/images/header/history.svg" alt="{{ 'GENERAL.LIBRARY' | translate }}">
    </div>
  }

  <div class="header-select responsive-off">
    <mat-form-field class="translate-select" appearance="outline">
      <mat-select #langSelect (selectionChange)="onSelectChange(langSelect.value)" [(value)]="currentLang" panelWidth="150px">
        @for (lang of langs; track lang) {
          <mat-option [value]="lang">{{lang}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>


  <button class="button-menu responsive-on" matIconButton [matMenuTriggerFor]="menu" (click)="resetAssistanceMenu()">
    <mat-icon class="notranslate">menu</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item>
      <div class="members-button" (click)="switchMembers()">
        <img class="icon" src="/assets/images/buttons/contacts.svg" alt="Icono">
        <span>{{ 'PARTICIPANTS' | translate }}</span>
      </div>
    </button>
    @if ((isExpert && userDataService.assetInfo.parentId == 0) || userDataService.assetInfo.parentId > 0) {
      <button mat-menu-item>
        <div class="members-button" (click)="switchAssistance()">
          <img class="icon" src="/assets/images/buttons/assistances.png" alt="Icono">
          <span>{{ 'GENERAL.ASSISTANCE' | translate }}</span>
        </div>
      </button>
    }
    @if (isExpert) {
      <button mat-menu-item>
        <div class="members-button" (click)="switchComments()">
          <img class="icon" src="/assets/images/buttons/comments.svg" alt="Icono">
          <span>{{ 'GENERAL.COMMENTS' | translate }}</span>
        </div>
      </button>
    }
    @if (isExpert) {
      <button mat-menu-item>
        <div class="members-button" title="{{ 'GENERAL.LIBRARY' | translate }}" (click)="openLibrary()">
          <img class="library icon" src="/assets/images/header/history.svg" alt="{{ 'GENERAL.LIBRARY' | translate }}">
          <span>{{ 'GENERAL.LIBRARY' | translate }}</span>
        </div>
      </button>
    }
    <button mat-menu-item [matMenuTriggerFor]="language">
      <div class="members-button">
        <img class="icon" src="/assets/images/header/lang.svg" alt="Language">
        <span>{{ 'LANGUAGE' | translate }}</span>
      </div>
    </button>
  </mat-menu>

  <mat-menu #language="matMenu">
    @for (lang of langs; track lang) {
      <button mat-menu-item [value]="lang" (click)="onSelectChange(lang)">
        <span>{{lang}}</span>
      </button>
    }
  </mat-menu>

</div>

@if (assistanceInfo) {
  <div class="assistance-responsive responsive-on">
    @if (!assistanceClosed) {
      <div class="assistance-responsive-content">
        <div class="assistance-combos">
          <mat-form-field class="assistances-select" appearance="outline">
            <mat-label>{{ 'ASSISTANCES.STATE' | translate }}</mat-label>
            <mat-select #stateSelect (selectionChange)="changeAssistanceStatus(stateSelect)" [(value)]="assistanceState" panelWidth="auto" [disabled]="!isExpert">
              @for (state of assisatancesStatesOptions; track state) {
                <mat-option [value]="state.value">{{ 'ASSISTANCES_STATES.' + state.key | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="assistances-select assistances-priority" appearance="outline">
            <mat-label>{{ 'ASSISTANCES_MODAL.PRIORITY' | translate }}</mat-label>
            <mat-select #prioritySelect (selectionChange)="changeAssistancePriority(prioritySelect)" [(value)]="assistancePriority" panelWidth="auto" [disabled]="!isExpert || userDataService.assetInfo.assistances[0].id == undefined">
              @for (key of objectKeys(assistancePriorityEnum); track key) {
                <mat-option [value]="assistancePriorityEnum[key]">{{ 'ASSISTANCES_PRIORITY.' + key | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }
    @if (assistanceClosed) {
      <div class="assistance-responsive-content-reopen">
        <div class="assistance-responsive-reopen">
          <button mat-raised-button (click)="reopenAssistance()" [disabled]="!isExpert">{{ 'ASSISTANCES.REOPEN_ASSISTANCE' | translate }}</button>
        </div>
      </div>
    }
  </div>
}
